<template>
  <div class="filters-box-row">
		<div class="filters-container">
			<div class="input-box">
				<span>店铺名称：</span>
				<el-input
					v-model="shopname"
					placeholder="请输入店铺名称"
					class="filter-input"
					size="small"
					@keyup.enter.native="search"
				></el-input>
			</div>
			<div class="input-box">
				<span>店铺状态：</span>
				<el-select v-model="stopflag" class="filter-input" size='small'>
					<el-option value="-1" label="全部"></el-option>
					<el-option value="0" label="启用"></el-option>
					<el-option value="1" label="停用"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>营业状态：</span>
				<el-select v-model="shopstate" class="filter-input" size='small'>
					<el-option value="-1" label="全部"></el-option>
					<el-option value="0" label="营业中"></el-option>
					<el-option value="1" label="未营业"></el-option>
				</el-select>
			</div>
			<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
			<el-button size="small" plain class="btn fx-btn" @click="clear">清空</el-button>
			<!-- <el-button size="small" type="text" class="btn" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
			</el-button> -->
		</div>
		<!-- <div class="filters-container" v-if="!collapse">
			<div class="input-box">
				<span>证照状态：</span>
				<el-select v-model="applystatue" class="filter-input" size='small'>
					<el-option value="-1" label="全部"></el-option>
					<el-option value="4" label="待提交"></el-option>
					<el-option value="0" label="待审核"></el-option>
					<el-option value="2" label="审核未通过"></el-option>
					<el-option value="1" label="审核成功"></el-option>
					<el-option value="3" label="证照过期"></el-option>
				</el-select>
			</div>
			<div class="input-box">
				<span>店铺来源：</span>
				<el-select v-model="sourceflag" class="filter-input" size='small'>
					<el-option value="-1" label="全部"></el-option>
					<el-option value="0" label="手动创建"></el-option>
					<el-option value="1" label="其它来源"></el-option>
				</el-select>
			</div>
		</div> -->
  </div>
</template>

<script>
export default {
	name: 'search',
	data () {
		return {
			shopname: '',
			stopflag: '-1',
			shopstate: '-1',
			// applystatue: '-1',
			// sourceflag: '-1',
			collapse: false
		}
	},
	created () {
		let a = window.sessionStorage.getItem('shopInfo')
		if (a) {
			let b = JSON.parse(a)
			this.shopname = b.shopname + ''
			this.stopflag = b.stopflag + ''
			this.shopstate = b.shopstate + ''
			// this.applystatue = b.applystatue + ''
			// this.sourceflag = b.sourceflag + ''
			this.search()
		}
	},
	methods: {
		handleCollapse () {
			this.collapse = !this.collapse
		},
		search () {
			this.$emit('handleSearch', { shopname: this.shopname, stopflag: this.stopflag, shopstate: this.shopstate })
		},
		clear () {
			this.shopname = ''
			this.stopflag = '-1'
			this.shopstate = '-1'
			// this.applystatue = '-1'
			// this.sourceflag = '-1'
			this.search()
		}
	}
}
</script>

<style lang="stylus" scoped>
.min-height1{
	min-height :70px
}
.min-height2{
	min-height :130px
}
.filters-box-row {
	display: flex;
	flex-direction column
	padding: 10px 0;
	width :100%;
	line-height :60px;
	min-width :600px;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		height: 60px
		.input-box {
			display flex
			width: 250px
			margin-left: 20px
			span {
				margin-right: 10px
			}
			.filter-input {
				flex: 1
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
}
</style>
